import { GUIDE_URL } from '../config/guideConfig';
import type { GuideArticle } from '../types/guide';
import { fetchWithCache } from './cache';

export const fetchGuide = (): Promise<GuideArticle[]> =>
  fetchWithCache('guide', async () => {
    const response = await fetch(GUIDE_URL);

    if (!response.ok) {
      throw new Error(`Failed to fetch guide: ${response.status}`);
    }

    return (await response.json()) as GuideArticle[];
  });
